import { type ReactNode } from 'react';

import type { ButtonOrLinkData } from 'components/ButtonOrLink/ButtonOrLinkData';
import {
  SearchHitActions,
  SearchHitCardInner,
  SearchHitContent,
  SearchHitHoverEffect,
  SearchHitLink,
} from 'modules/search/components/Hit/SearchHit.styled';

type Props = {
  actions?: ReactNode;
  roundedTop?: boolean;
  highlighted?: boolean;
  children: ReactNode;
  listingLinkData: ButtonOrLinkData;
  onClick?: () => void;
};

export function SearchHitInteractiveContentWrapper({
  actions,
  roundedTop,
  highlighted,
  children,
  listingLinkData,
  onClick,
}: Props) {
  if (actions)
    return (
      <SearchHitCardInner
        $roundedTop={Boolean(roundedTop)}
        $highlighted={Boolean(highlighted)}
      >
        <SearchHitContent>{children}</SearchHitContent>
        <SearchHitActions>{actions}</SearchHitActions>
      </SearchHitCardInner>
    );

  return (
    <SearchHitLink
      $roundedTop={Boolean(roundedTop)}
      $highlighted={Boolean(highlighted)}
      data={listingLinkData}
      onClick={onClick}
    >
      <SearchHitHoverEffect />
      <SearchHitContent>{children}</SearchHitContent>
    </SearchHitLink>
  );
}
